"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const usePriceStyle = (strikeThrough) => {
    const theme = (0, material_1.useTheme)();
    const container = Object.assign(Object.assign({ fontSize: 'inherit' }, (strikeThrough && {
        fontSize: '10px',
        color: theme.qlub.palette.onSurfaceColors.disabled,
        textDecoration: 'line-through',
        display: 'inline-flex',
        alignItems: 'flex-end',
        paddingBottom: '3px',
    })), { '>span': {
            fontSize: 10,
            marginRight: '2px',
            display: 'inline-block',
            "html[dir='rtl'] &": {
                marginLeft: '2px',
            },
        } });
    const boldPrice = {
        fontWeight: 500,
    };
    return {
        container,
        boldPrice,
    };
};
exports.default = usePriceStyle;
